/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    AdminDeliveryPayloadAssignShipmentsRequestPayload,
    AdminDeliveryPayloadCreateBlackoutRequestPayload,
    AdminDeliveryPayloadCreateFollowRequestPayload,
    AdminDeliveryPayloadCreateRunRequestPayload,
    AdminDeliveryPayloadCreateZoneRequestPayload,
    AdminDeliveryPayloadPublishRunRequestPayload,
    AdminDeliveryPayloadReorderRunRequestPayload,
    AdminDeliveryPayloadRescheduleShipmentRequestPayload,
    AdminDeliveryPayloadUnassignShipmentRequestPayload,
    AdminDeliveryPayloadUpdateZoneRequestPayload,
    AdminDeliveryPayloadUpsertZoneWindowsRequestPayload,
    AdminDeliveryResponseAssignShipmentsResponse,
    AdminDeliveryResponseCreateBlackoutResponse,
    AdminDeliveryResponseCreateFollowResponse,
    AdminDeliveryResponseCreateRunResponse,
    AdminDeliveryResponseCreateZoneResponse,
    AdminDeliveryResponseDeleteBlackoutResponse,
    AdminDeliveryResponseDeleteFollowResponse,
    AdminDeliveryResponseDeleteZoneResponse,
    AdminDeliveryResponseGetPlanResponse,
    AdminDeliveryResponseGetShipmentAvailabilityResponse,
    AdminDeliveryResponseListBlackoutsResponse,
    AdminDeliveryResponseListDriversResponse,
    AdminDeliveryResponseListFollowsResponse,
    AdminDeliveryResponseListZonesResponse,
    AdminDeliveryResponsePublishRunResponse,
    AdminDeliveryResponseReorderRunResponse,
    AdminDeliveryResponseRescheduleShipmentResponse,
    AdminDeliveryResponseUnassignShipmentResponse,
    AdminDeliveryResponseUpdateZoneResponse,
    AdminDeliveryResponseUpsertZoneWindowsResponse,
    ApiErrorEnvelope,
    DeliveryAvailabilityPayloadFetchAvailabilityRequestPayload,
    DeliveryAvailabilityPayloadReserveSlotRequestPayload,
    DeliveryAvailabilityResponseFetchAvailabilityResponse,
    DeliveryAvailabilityResponseReserveSlotResponse,
} from '../models/index';

export interface AdminDeliveryAssignShipmentsRequest {
    deliveryRunId: string;
    adminDeliveryPayloadAssignShipmentsRequestPayload: AdminDeliveryPayloadAssignShipmentsRequestPayload;
}

export interface AdminDeliveryCreateBlackoutRequest {
    adminDeliveryPayloadCreateBlackoutRequestPayload: AdminDeliveryPayloadCreateBlackoutRequestPayload;
}

export interface AdminDeliveryCreateFollowRequest {
    adminDeliveryPayloadCreateFollowRequestPayload: AdminDeliveryPayloadCreateFollowRequestPayload;
}

export interface AdminDeliveryCreateRunRequest {
    adminDeliveryPayloadCreateRunRequestPayload: AdminDeliveryPayloadCreateRunRequestPayload;
}

export interface AdminDeliveryCreateZoneRequest {
    adminDeliveryPayloadCreateZoneRequestPayload: AdminDeliveryPayloadCreateZoneRequestPayload;
}

export interface AdminDeliveryDeleteBlackoutRequest {
    deliveryBlackoutId: string;
}

export interface AdminDeliveryDeleteFollowRequest {
    adminDeliveryFollowId: string;
}

export interface AdminDeliveryDeleteZoneRequest {
    deliveryZoneId: string;
}

export interface AdminDeliveryGetPlanRequest {
    serviceDate?: string;
}

export interface AdminDeliveryGetShipmentAvailabilityRequest {
    shipmentId: string;
}

export interface AdminDeliveryPublishRunRequest {
    deliveryRunId: string;
    adminDeliveryPayloadPublishRunRequestPayload: AdminDeliveryPayloadPublishRunRequestPayload;
}

export interface AdminDeliveryReorderRunRequest {
    deliveryRunId: string;
    adminDeliveryPayloadReorderRunRequestPayload: AdminDeliveryPayloadReorderRunRequestPayload;
}

export interface AdminDeliveryRescheduleShipmentRequest {
    shipmentId: string;
    adminDeliveryPayloadRescheduleShipmentRequestPayload: AdminDeliveryPayloadRescheduleShipmentRequestPayload;
}

export interface AdminDeliveryUnassignShipmentRequest {
    deliveryRunId: string;
    shipmentId: string;
    adminDeliveryPayloadUnassignShipmentRequestPayload: AdminDeliveryPayloadUnassignShipmentRequestPayload;
}

export interface AdminDeliveryUpdateZoneRequest {
    deliveryZoneId: string;
    adminDeliveryPayloadUpdateZoneRequestPayload: AdminDeliveryPayloadUpdateZoneRequestPayload;
}

export interface AdminDeliveryUpsertZoneWindowsRequest {
    deliveryZoneId: string;
    adminDeliveryPayloadUpsertZoneWindowsRequestPayload: AdminDeliveryPayloadUpsertZoneWindowsRequestPayload;
}

export interface DeliveryAvailabilityFetchAvailabilityRequest {
    deliveryAvailabilityPayloadFetchAvailabilityRequestPayload: DeliveryAvailabilityPayloadFetchAvailabilityRequestPayload;
}

export interface DeliveryAvailabilityReserveSlotRequest {
    deliveryAvailabilityPayloadReserveSlotRequestPayload: DeliveryAvailabilityPayloadReserveSlotRequestPayload;
}

/**
 *
 */
export class DeliveryApi extends runtime.BaseAPI {

    /**
     * Creates request options for adminDeliveryAssignShipments without sending the request
     */
    async adminDeliveryAssignShipmentsRequestOpts(requestParameters: AdminDeliveryAssignShipmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryRunId'] == null) {
            throw new runtime.RequiredError(
                'deliveryRunId',
                'Required parameter "deliveryRunId" was null or undefined when calling adminDeliveryAssignShipments().'
            );
        }

        if (requestParameters['adminDeliveryPayloadAssignShipmentsRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadAssignShipmentsRequestPayload',
                'Required parameter "adminDeliveryPayloadAssignShipmentsRequestPayload" was null or undefined when calling adminDeliveryAssignShipments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-runs/{deliveryRunId}/shipments`;
        urlPath = urlPath.replace('{deliveryRunId}', encodeURIComponent(String(requestParameters['deliveryRunId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadAssignShipmentsRequestPayload'],
        };
    }

    /**
     * Assign Shipments
     */
    async adminDeliveryAssignShipmentsRaw(requestParameters: AdminDeliveryAssignShipmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseAssignShipmentsResponse>> {
        const requestOptions = await this.adminDeliveryAssignShipmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Assign Shipments
     */
    async adminDeliveryAssignShipments(requestParameters: AdminDeliveryAssignShipmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseAssignShipmentsResponse> {
        const response = await this.adminDeliveryAssignShipmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryCreateBlackout without sending the request
     */
    async adminDeliveryCreateBlackoutRequestOpts(requestParameters: AdminDeliveryCreateBlackoutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminDeliveryPayloadCreateBlackoutRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadCreateBlackoutRequestPayload',
                'Required parameter "adminDeliveryPayloadCreateBlackoutRequestPayload" was null or undefined when calling adminDeliveryCreateBlackout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-blackouts`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadCreateBlackoutRequestPayload'],
        };
    }

    /**
     * Create Blackout
     */
    async adminDeliveryCreateBlackoutRaw(requestParameters: AdminDeliveryCreateBlackoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseCreateBlackoutResponse>> {
        const requestOptions = await this.adminDeliveryCreateBlackoutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create Blackout
     */
    async adminDeliveryCreateBlackout(requestParameters: AdminDeliveryCreateBlackoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseCreateBlackoutResponse> {
        const response = await this.adminDeliveryCreateBlackoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryCreateFollow without sending the request
     */
    async adminDeliveryCreateFollowRequestOpts(requestParameters: AdminDeliveryCreateFollowRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminDeliveryPayloadCreateFollowRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadCreateFollowRequestPayload',
                'Required parameter "adminDeliveryPayloadCreateFollowRequestPayload" was null or undefined when calling adminDeliveryCreateFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-follows`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadCreateFollowRequestPayload'],
        };
    }

    /**
     * Create Follow
     */
    async adminDeliveryCreateFollowRaw(requestParameters: AdminDeliveryCreateFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseCreateFollowResponse>> {
        const requestOptions = await this.adminDeliveryCreateFollowRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create Follow
     */
    async adminDeliveryCreateFollow(requestParameters: AdminDeliveryCreateFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseCreateFollowResponse> {
        const response = await this.adminDeliveryCreateFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryCreateRun without sending the request
     */
    async adminDeliveryCreateRunRequestOpts(requestParameters: AdminDeliveryCreateRunRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminDeliveryPayloadCreateRunRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadCreateRunRequestPayload',
                'Required parameter "adminDeliveryPayloadCreateRunRequestPayload" was null or undefined when calling adminDeliveryCreateRun().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-runs`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadCreateRunRequestPayload'],
        };
    }

    /**
     * Create Run
     */
    async adminDeliveryCreateRunRaw(requestParameters: AdminDeliveryCreateRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseCreateRunResponse>> {
        const requestOptions = await this.adminDeliveryCreateRunRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create Run
     */
    async adminDeliveryCreateRun(requestParameters: AdminDeliveryCreateRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseCreateRunResponse> {
        const response = await this.adminDeliveryCreateRunRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryCreateZone without sending the request
     */
    async adminDeliveryCreateZoneRequestOpts(requestParameters: AdminDeliveryCreateZoneRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminDeliveryPayloadCreateZoneRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadCreateZoneRequestPayload',
                'Required parameter "adminDeliveryPayloadCreateZoneRequestPayload" was null or undefined when calling adminDeliveryCreateZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-zones`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadCreateZoneRequestPayload'],
        };
    }

    /**
     * Create Zone
     */
    async adminDeliveryCreateZoneRaw(requestParameters: AdminDeliveryCreateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseCreateZoneResponse>> {
        const requestOptions = await this.adminDeliveryCreateZoneRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create Zone
     */
    async adminDeliveryCreateZone(requestParameters: AdminDeliveryCreateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseCreateZoneResponse> {
        const response = await this.adminDeliveryCreateZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryDeleteBlackout without sending the request
     */
    async adminDeliveryDeleteBlackoutRequestOpts(requestParameters: AdminDeliveryDeleteBlackoutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryBlackoutId'] == null) {
            throw new runtime.RequiredError(
                'deliveryBlackoutId',
                'Required parameter "deliveryBlackoutId" was null or undefined when calling adminDeliveryDeleteBlackout().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-blackouts/{deliveryBlackoutId}`;
        urlPath = urlPath.replace('{deliveryBlackoutId}', encodeURIComponent(String(requestParameters['deliveryBlackoutId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Blackout
     */
    async adminDeliveryDeleteBlackoutRaw(requestParameters: AdminDeliveryDeleteBlackoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseDeleteBlackoutResponse>> {
        const requestOptions = await this.adminDeliveryDeleteBlackoutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Blackout
     */
    async adminDeliveryDeleteBlackout(requestParameters: AdminDeliveryDeleteBlackoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseDeleteBlackoutResponse> {
        const response = await this.adminDeliveryDeleteBlackoutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryDeleteFollow without sending the request
     */
    async adminDeliveryDeleteFollowRequestOpts(requestParameters: AdminDeliveryDeleteFollowRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminDeliveryFollowId'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryFollowId',
                'Required parameter "adminDeliveryFollowId" was null or undefined when calling adminDeliveryDeleteFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-follows/{adminDeliveryFollowId}`;
        urlPath = urlPath.replace('{adminDeliveryFollowId}', encodeURIComponent(String(requestParameters['adminDeliveryFollowId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Follow
     */
    async adminDeliveryDeleteFollowRaw(requestParameters: AdminDeliveryDeleteFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseDeleteFollowResponse>> {
        const requestOptions = await this.adminDeliveryDeleteFollowRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Follow
     */
    async adminDeliveryDeleteFollow(requestParameters: AdminDeliveryDeleteFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseDeleteFollowResponse> {
        const response = await this.adminDeliveryDeleteFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryDeleteZone without sending the request
     */
    async adminDeliveryDeleteZoneRequestOpts(requestParameters: AdminDeliveryDeleteZoneRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryZoneId'] == null) {
            throw new runtime.RequiredError(
                'deliveryZoneId',
                'Required parameter "deliveryZoneId" was null or undefined when calling adminDeliveryDeleteZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-zones/{deliveryZoneId}`;
        urlPath = urlPath.replace('{deliveryZoneId}', encodeURIComponent(String(requestParameters['deliveryZoneId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Zone
     */
    async adminDeliveryDeleteZoneRaw(requestParameters: AdminDeliveryDeleteZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseDeleteZoneResponse>> {
        const requestOptions = await this.adminDeliveryDeleteZoneRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Zone
     */
    async adminDeliveryDeleteZone(requestParameters: AdminDeliveryDeleteZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseDeleteZoneResponse> {
        const response = await this.adminDeliveryDeleteZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryGetPlan without sending the request
     */
    async adminDeliveryGetPlanRequestOpts(requestParameters: AdminDeliveryGetPlanRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['serviceDate'] != null) {
            queryParameters['serviceDate'] = requestParameters['serviceDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-plan`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Plan
     */
    async adminDeliveryGetPlanRaw(requestParameters: AdminDeliveryGetPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseGetPlanResponse>> {
        const requestOptions = await this.adminDeliveryGetPlanRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Plan
     */
    async adminDeliveryGetPlan(requestParameters: AdminDeliveryGetPlanRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseGetPlanResponse> {
        const response = await this.adminDeliveryGetPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryGetShipmentAvailability without sending the request
     */
    async adminDeliveryGetShipmentAvailabilityRequestOpts(requestParameters: AdminDeliveryGetShipmentAvailabilityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling adminDeliveryGetShipmentAvailability().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/shipments/{shipmentId}/availability`;
        urlPath = urlPath.replace('{shipmentId}', encodeURIComponent(String(requestParameters['shipmentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Shipment Availability
     */
    async adminDeliveryGetShipmentAvailabilityRaw(requestParameters: AdminDeliveryGetShipmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseGetShipmentAvailabilityResponse>> {
        const requestOptions = await this.adminDeliveryGetShipmentAvailabilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Shipment Availability
     */
    async adminDeliveryGetShipmentAvailability(requestParameters: AdminDeliveryGetShipmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseGetShipmentAvailabilityResponse> {
        const response = await this.adminDeliveryGetShipmentAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryListBlackouts without sending the request
     */
    async adminDeliveryListBlackoutsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-blackouts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Blackouts
     */
    async adminDeliveryListBlackoutsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseListBlackoutsResponse>> {
        const requestOptions = await this.adminDeliveryListBlackoutsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List Blackouts
     */
    async adminDeliveryListBlackouts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseListBlackoutsResponse> {
        const response = await this.adminDeliveryListBlackoutsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryListDrivers without sending the request
     */
    async adminDeliveryListDriversRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-drivers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Drivers
     */
    async adminDeliveryListDriversRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseListDriversResponse>> {
        const requestOptions = await this.adminDeliveryListDriversRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List Drivers
     */
    async adminDeliveryListDrivers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseListDriversResponse> {
        const response = await this.adminDeliveryListDriversRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryListFollows without sending the request
     */
    async adminDeliveryListFollowsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-follows`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Follows
     */
    async adminDeliveryListFollowsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseListFollowsResponse>> {
        const requestOptions = await this.adminDeliveryListFollowsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List Follows
     */
    async adminDeliveryListFollows(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseListFollowsResponse> {
        const response = await this.adminDeliveryListFollowsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryListZones without sending the request
     */
    async adminDeliveryListZonesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/delivery-zones`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Zones
     */
    async adminDeliveryListZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseListZonesResponse>> {
        const requestOptions = await this.adminDeliveryListZonesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List Zones
     */
    async adminDeliveryListZones(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseListZonesResponse> {
        const response = await this.adminDeliveryListZonesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryPublishRun without sending the request
     */
    async adminDeliveryPublishRunRequestOpts(requestParameters: AdminDeliveryPublishRunRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryRunId'] == null) {
            throw new runtime.RequiredError(
                'deliveryRunId',
                'Required parameter "deliveryRunId" was null or undefined when calling adminDeliveryPublishRun().'
            );
        }

        if (requestParameters['adminDeliveryPayloadPublishRunRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadPublishRunRequestPayload',
                'Required parameter "adminDeliveryPayloadPublishRunRequestPayload" was null or undefined when calling adminDeliveryPublishRun().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-runs/{deliveryRunId}/publish`;
        urlPath = urlPath.replace('{deliveryRunId}', encodeURIComponent(String(requestParameters['deliveryRunId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadPublishRunRequestPayload'],
        };
    }

    /**
     * Publish Run
     */
    async adminDeliveryPublishRunRaw(requestParameters: AdminDeliveryPublishRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponsePublishRunResponse>> {
        const requestOptions = await this.adminDeliveryPublishRunRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Publish Run
     */
    async adminDeliveryPublishRun(requestParameters: AdminDeliveryPublishRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponsePublishRunResponse> {
        const response = await this.adminDeliveryPublishRunRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryReorderRun without sending the request
     */
    async adminDeliveryReorderRunRequestOpts(requestParameters: AdminDeliveryReorderRunRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryRunId'] == null) {
            throw new runtime.RequiredError(
                'deliveryRunId',
                'Required parameter "deliveryRunId" was null or undefined when calling adminDeliveryReorderRun().'
            );
        }

        if (requestParameters['adminDeliveryPayloadReorderRunRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadReorderRunRequestPayload',
                'Required parameter "adminDeliveryPayloadReorderRunRequestPayload" was null or undefined when calling adminDeliveryReorderRun().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-runs/{deliveryRunId}/sequence`;
        urlPath = urlPath.replace('{deliveryRunId}', encodeURIComponent(String(requestParameters['deliveryRunId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadReorderRunRequestPayload'],
        };
    }

    /**
     * Reorder Run
     */
    async adminDeliveryReorderRunRaw(requestParameters: AdminDeliveryReorderRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseReorderRunResponse>> {
        const requestOptions = await this.adminDeliveryReorderRunRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Reorder Run
     */
    async adminDeliveryReorderRun(requestParameters: AdminDeliveryReorderRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseReorderRunResponse> {
        const response = await this.adminDeliveryReorderRunRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryRescheduleShipment without sending the request
     */
    async adminDeliveryRescheduleShipmentRequestOpts(requestParameters: AdminDeliveryRescheduleShipmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling adminDeliveryRescheduleShipment().'
            );
        }

        if (requestParameters['adminDeliveryPayloadRescheduleShipmentRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadRescheduleShipmentRequestPayload',
                'Required parameter "adminDeliveryPayloadRescheduleShipmentRequestPayload" was null or undefined when calling adminDeliveryRescheduleShipment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/shipments/{shipmentId}/reschedule`;
        urlPath = urlPath.replace('{shipmentId}', encodeURIComponent(String(requestParameters['shipmentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadRescheduleShipmentRequestPayload'],
        };
    }

    /**
     * Reschedule Shipment
     */
    async adminDeliveryRescheduleShipmentRaw(requestParameters: AdminDeliveryRescheduleShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseRescheduleShipmentResponse>> {
        const requestOptions = await this.adminDeliveryRescheduleShipmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Reschedule Shipment
     */
    async adminDeliveryRescheduleShipment(requestParameters: AdminDeliveryRescheduleShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseRescheduleShipmentResponse> {
        const response = await this.adminDeliveryRescheduleShipmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryUnassignShipment without sending the request
     */
    async adminDeliveryUnassignShipmentRequestOpts(requestParameters: AdminDeliveryUnassignShipmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryRunId'] == null) {
            throw new runtime.RequiredError(
                'deliveryRunId',
                'Required parameter "deliveryRunId" was null or undefined when calling adminDeliveryUnassignShipment().'
            );
        }

        if (requestParameters['shipmentId'] == null) {
            throw new runtime.RequiredError(
                'shipmentId',
                'Required parameter "shipmentId" was null or undefined when calling adminDeliveryUnassignShipment().'
            );
        }

        if (requestParameters['adminDeliveryPayloadUnassignShipmentRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadUnassignShipmentRequestPayload',
                'Required parameter "adminDeliveryPayloadUnassignShipmentRequestPayload" was null or undefined when calling adminDeliveryUnassignShipment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-runs/{deliveryRunId}/shipments/{shipmentId}`;
        urlPath = urlPath.replace('{deliveryRunId}', encodeURIComponent(String(requestParameters['deliveryRunId'])));
        urlPath = urlPath.replace('{shipmentId}', encodeURIComponent(String(requestParameters['shipmentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadUnassignShipmentRequestPayload'],
        };
    }

    /**
     * Unassign Shipment
     */
    async adminDeliveryUnassignShipmentRaw(requestParameters: AdminDeliveryUnassignShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseUnassignShipmentResponse>> {
        const requestOptions = await this.adminDeliveryUnassignShipmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Unassign Shipment
     */
    async adminDeliveryUnassignShipment(requestParameters: AdminDeliveryUnassignShipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseUnassignShipmentResponse> {
        const response = await this.adminDeliveryUnassignShipmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryUpdateZone without sending the request
     */
    async adminDeliveryUpdateZoneRequestOpts(requestParameters: AdminDeliveryUpdateZoneRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryZoneId'] == null) {
            throw new runtime.RequiredError(
                'deliveryZoneId',
                'Required parameter "deliveryZoneId" was null or undefined when calling adminDeliveryUpdateZone().'
            );
        }

        if (requestParameters['adminDeliveryPayloadUpdateZoneRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadUpdateZoneRequestPayload',
                'Required parameter "adminDeliveryPayloadUpdateZoneRequestPayload" was null or undefined when calling adminDeliveryUpdateZone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-zones/{deliveryZoneId}`;
        urlPath = urlPath.replace('{deliveryZoneId}', encodeURIComponent(String(requestParameters['deliveryZoneId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadUpdateZoneRequestPayload'],
        };
    }

    /**
     * Update Zone
     */
    async adminDeliveryUpdateZoneRaw(requestParameters: AdminDeliveryUpdateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseUpdateZoneResponse>> {
        const requestOptions = await this.adminDeliveryUpdateZoneRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Zone
     */
    async adminDeliveryUpdateZone(requestParameters: AdminDeliveryUpdateZoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseUpdateZoneResponse> {
        const response = await this.adminDeliveryUpdateZoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeliveryUpsertZoneWindows without sending the request
     */
    async adminDeliveryUpsertZoneWindowsRequestOpts(requestParameters: AdminDeliveryUpsertZoneWindowsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryZoneId'] == null) {
            throw new runtime.RequiredError(
                'deliveryZoneId',
                'Required parameter "deliveryZoneId" was null or undefined when calling adminDeliveryUpsertZoneWindows().'
            );
        }

        if (requestParameters['adminDeliveryPayloadUpsertZoneWindowsRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'adminDeliveryPayloadUpsertZoneWindowsRequestPayload',
                'Required parameter "adminDeliveryPayloadUpsertZoneWindowsRequestPayload" was null or undefined when calling adminDeliveryUpsertZoneWindows().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/delivery-zones/{deliveryZoneId}/windows`;
        urlPath = urlPath.replace('{deliveryZoneId}', encodeURIComponent(String(requestParameters['deliveryZoneId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminDeliveryPayloadUpsertZoneWindowsRequestPayload'],
        };
    }

    /**
     * Upsert Zone Windows
     */
    async adminDeliveryUpsertZoneWindowsRaw(requestParameters: AdminDeliveryUpsertZoneWindowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDeliveryResponseUpsertZoneWindowsResponse>> {
        const requestOptions = await this.adminDeliveryUpsertZoneWindowsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Upsert Zone Windows
     */
    async adminDeliveryUpsertZoneWindows(requestParameters: AdminDeliveryUpsertZoneWindowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDeliveryResponseUpsertZoneWindowsResponse> {
        const response = await this.adminDeliveryUpsertZoneWindowsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deliveryAvailabilityFetchAvailability without sending the request
     */
    async deliveryAvailabilityFetchAvailabilityRequestOpts(requestParameters: DeliveryAvailabilityFetchAvailabilityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryAvailabilityPayloadFetchAvailabilityRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'deliveryAvailabilityPayloadFetchAvailabilityRequestPayload',
                'Required parameter "deliveryAvailabilityPayloadFetchAvailabilityRequestPayload" was null or undefined when calling deliveryAvailabilityFetchAvailability().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/delivery/availability`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['deliveryAvailabilityPayloadFetchAvailabilityRequestPayload'],
        };
    }

    /**
     * Fetch Availability
     */
    async deliveryAvailabilityFetchAvailabilityRaw(requestParameters: DeliveryAvailabilityFetchAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryAvailabilityResponseFetchAvailabilityResponse>> {
        const requestOptions = await this.deliveryAvailabilityFetchAvailabilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch Availability
     */
    async deliveryAvailabilityFetchAvailability(requestParameters: DeliveryAvailabilityFetchAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryAvailabilityResponseFetchAvailabilityResponse> {
        const response = await this.deliveryAvailabilityFetchAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deliveryAvailabilityReserveSlot without sending the request
     */
    async deliveryAvailabilityReserveSlotRequestOpts(requestParameters: DeliveryAvailabilityReserveSlotRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deliveryAvailabilityPayloadReserveSlotRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'deliveryAvailabilityPayloadReserveSlotRequestPayload',
                'Required parameter "deliveryAvailabilityPayloadReserveSlotRequestPayload" was null or undefined when calling deliveryAvailabilityReserveSlot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/delivery/reservations`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['deliveryAvailabilityPayloadReserveSlotRequestPayload'],
        };
    }

    /**
     * Reserve Slot
     */
    async deliveryAvailabilityReserveSlotRaw(requestParameters: DeliveryAvailabilityReserveSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryAvailabilityResponseReserveSlotResponse>> {
        const requestOptions = await this.deliveryAvailabilityReserveSlotRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Reserve Slot
     */
    async deliveryAvailabilityReserveSlot(requestParameters: DeliveryAvailabilityReserveSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryAvailabilityResponseReserveSlotResponse> {
        const response = await this.deliveryAvailabilityReserveSlotRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
